import { useEffect, useState } from 'react';
import { MS_PER_DAY, BMAC_DAYS_THRESHOLD } from '@nudge/shared';
import { useAuthStore } from '../../stores/auth';
import { useSettingsStore } from '../../stores/settings';

const BMAC_URL = 'https://buymeacoffee.com/nudgeapp';

export function BmacPrompt() {
  const user = useAuthStore((s) => s.user);
  const update = useSettingsStore((s) => s.update);
  const settings = useSettingsStore((s) => s.settings);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!user || !settings.first_card_at || settings.bmac_prompt_shown) return;
    const elapsedDays = (Date.now() - new Date(settings.first_card_at).getTime()) / MS_PER_DAY;
    if (elapsedDays >= BMAC_DAYS_THRESHOLD) setShow(true);
  }, [user, settings.first_card_at, settings.bmac_prompt_shown]);

  if (!show) return null;

  function dismiss() {
    setShow(false);
    void update({ bmac_prompt_shown: true });
  }

  return (
    <div className="fixed inset-x-0 bottom-20 z-40 mx-auto w-full max-w-sm px-4">
      <div className="rounded-2xl border border-amber/30 bg-card p-4 shadow-xl">
        <div className="flex items-start gap-3">
          <span className="text-2xl" aria-hidden>☕</span>
          <div className="flex-1">
            <div className="text-sm font-medium text-text-primary">Enjoying Nudge?</div>
            <div className="mt-1 text-xs text-text-muted">If it's helped your circle communicate, you can support development.</div>
          </div>
        </div>
        <div className="mt-3 flex gap-2">
          <a href={BMAC_URL} target="_blank" rel="noreferrer" onClick={dismiss}
            className="flex-1 rounded-lg bg-amber py-2 text-center text-xs font-medium text-white">
            Buy me a coffee
          </a>
          <button onClick={dismiss} className="rounded-lg border border-border-subtle bg-surface px-3 py-2 text-xs text-text-muted">
            No thanks
          </button>
        </div>
      </div>
    </div>
  );
}
